/* SVE FAQ page: search-as-you-type, topic chips, open-on-anchor and copy-link.
   Works with sections/sve-faq-hero.liquid (search box) and sve-faq-list.liquid. */
(function () {
  if (window.sveFaqInit) return;
  window.sveFaqInit = true;

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }

  function init() {
    var root = document.querySelector('[data-sve-faq]');
    if (!root) return;
    var input = document.querySelector('[data-sve-faq-search]');
    var clear = document.querySelector('[data-sve-faq-clear]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-sve-faq-chip]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sve-faq-group]'));
    var empty = root.querySelector('[data-sve-faq-empty]');
    var status = root.querySelector('[data-sve-faq-status]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sve-faq-item]')).map(function (el) {
      return { el: el, text: norm(el.textContent) };
    });
    var state = { chip: 'all', q: '' };

    function apply() {
      var words = state.q ? state.q.split(' ') : [];
      var total = 0;
      groups.forEach(function (g) {
        var inTopic = state.chip === 'all' || g.getAttribute('data-sve-faq-group') === state.chip;
        var shown = 0;
        items.forEach(function (it) {
          if (!g.contains(it.el)) return;
          var ok = inTopic && words.every(function (w) { return it.text.indexOf(w) !== -1; });
          it.el.hidden = !ok;
          if (ok) shown++;
        });
        g.hidden = shown === 0;
        total += shown;
      });
      if (empty) empty.hidden = total !== 0;
      if (status) {
        status.textContent = state.q
          ? (total === 1 ? root.dataset.countOne : (root.dataset.countOther || '').replace('[count]', total))
          : '';
      }
    }

    function setChip(slug) {
      state.chip = slug;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-sve-faq-chip') === slug ? 'true' : 'false'); });
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        setChip(c.getAttribute('data-sve-faq-chip'));
        apply();
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        state.q = norm(input.value);
        if (state.q && state.chip !== 'all') setChip('all');
        if (clear) clear.hidden = !input.value;
        apply();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var first = root.querySelector('[data-sve-faq-item]:not([hidden]) summary');
          if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        state.q = '';
        clear.hidden = true;
        apply();
        input.focus();
      });
    }

    function openFromHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      var el = document.getElementById(id);
      if (!el || !root.contains(el)) return;
      if (input) { input.value = ''; state.q = ''; if (clear) clear.hidden = true; }
      setChip('all');
      apply();
      if (el.tagName === 'DETAILS') {
        el.open = true;
        el.classList.add('is-flash');
        setTimeout(function () { el.classList.remove('is-flash'); }, 2500);
      }
      setTimeout(function () { el.scrollIntoView({ block: 'start' }); }, 60);
    }
    window.addEventListener('hashchange', openFromHash);
    openFromHash();

    /* Copy a link to one question (the hash opens it on arrival) */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sve-faq-anchor]');
      if (!a) return;
      e.preventDefault();
      var hash = a.getAttribute('href');
      var url = location.href.split('#')[0] + hash;
      if (history.replaceState) history.replaceState(null, '', hash);
      var label = a.querySelector('[data-label]');
      var old = label ? label.textContent : '';
      function done() {
        if (!label || a.dataset.busy) return;
        a.dataset.busy = '1';
        label.textContent = a.dataset.done || old;
        if (status) status.textContent = a.dataset.done || '';
        setTimeout(function () { label.textContent = old; delete a.dataset.busy; }, 3000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, done);
      } else {
        done();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
